const useCurrency = () => {
  const store = usePreferenceStore();

  const format = (value: number): string => {
    return `${store.moneySymbol} ${value.toFixed(2)}`;
  };

  return {
    format
  };
};

export { useCurrency };
